import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyBp_OO_c8HLhNoC4dKgLFB8fvxQCZLCOOo",
  authDomain: "rede-arena.firebaseapp.com",
  projectId: "rede-arena",
  storageBucket: "rede-arena.appspot.com",
  messagingSenderId: "1040795222667",
  appId: "1:1040795222667:web:4f7cef7876118974b28a8e",
  measurementId: "G-MQQN8EK2XX",
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const analytics = getAnalytics(app);
export const firestore = getFirestore(app);
export const database = getDatabase();
